module.exports = __webpack_public_path__ + "img/es.f13d627a.svg";